var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Tag",class:_vm.classList,on:{"click":_vm.toggle}},[(_vm.hasValidType)?_c('span',[_c('font-awesome-icon',{staticClass:"pin",attrs:{"icon":['fal', 'map-marker-alt']}})],1):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }